import React from "react";
import './Campaign.css';

import { Link } from "react-router-dom";



const Campaign = ({ campaign }) => {

    // Destructure raised and goal amounts from donation object
    const raised = campaign.donation.raised;
    const goal = campaign.donation.goal;

    // Calculate donation progress percentage
    const percentage = (raised / goal) * 100;
    const displayPercentage = Math.round(percentage); // rounds to nearest whole number

    return (

        <div className="campaign-item">

            <div className="image">
                <img src={campaign.image} alt={campaign.title} /> {/* Campaign Image */}
            </div>

            <div className="content">

                {/* Link to the individual Campaign page */}
                <Link
                    to={{
                        pathname: '/Campaigns/' + campaign.title,  // Navigate to the specific Campaign page
                    }}
                    location = {{campaign}}  // Passing Campaign details to the linked page
                    state= {campaign}>
                    <h3>{campaign.title}</h3> {/* Campaign Title */}
                </Link>

                <p>{campaign.content}</p> {/* Short campaign description */}

                {/* Progress bar section */}
                <div className="skill-bar">
                    <span className="skill-progress" style={{ width: `${displayPercentage}%` }}>
                        <span className="skill-no">{displayPercentage}%</span> {/* Display donation percentage */}
                    </span>
                </div>

                {/* Display raised and goal amounts */}
                <div className="amount">
                    <p><span>${campaign.donation.raised}</span> Raised</p>
                    <p><span>${campaign.donation.goal}</span> Goal</p>
                </div>

            </div>

        </div>
    );
};

export default Campaign;